import React from 'react'

const Instruction = ({ instruction }) => {
  let step = ''

  if (instruction && instruction !== '') step = instruction

  return <p dangerouslySetInnerHTML={{ __html: step }} />
}

export default Instruction



// WEBPACK FOOTER //
// ./src/Components/Instruction.js